(() => {
  'use strict';
  if (window.__fluffV2Loaded) return;
  window.__fluffV2Loaded = true;

  const SF_ENDPOINT = '/api/2026-04/graphql.json';
  const CART_CREATE = 'mutation FluffV2CartCreate($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl totalQuantity } userErrors { field message } } }';
  const ERR_CHECKOUT = 'حصلت مشكلة بسيطة في تجهيز طلبك. جرّب تاني، ولو فضلت كلمنا على واتساب.';
  const ERR_ADD = 'مقدرناش نضيفه للسلة دلوقتي. جرّب تاني.';

  const money = (cents) => Math.round(Number(cents || 0) / 100).toLocaleString('en-US') + ' ج.م';

  let toastEl = null;
  let toastTimer = 0;
  function toast(message, link) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fv2-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = '';
    const text = document.createElement('span');
    text.textContent = message;
    toastEl.appendChild(text);
    if (link) {
      const a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label;
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toastEl.classList.remove('is-visible'), 4500);
  }

  function publish(name, payload) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        const result = Shopify.analytics.publish(name, payload);
        if (result && typeof result.catch === 'function') result.catch(() => {});
      }
    } catch (_) {
      // Analytics must never block the order.
    }
  }

  function trustedCheckoutUrl(value) {
    const url = new URL(value, window.location.origin);
    const host = url.hostname;
    const root = window.location.hostname.replace(/^www\./, '');
    const ok = url.protocol === 'https:' && (host === window.location.hostname || host.endsWith('.myshopify.com') || host === root || host.endsWith('.' + root));
    if (!ok) throw new Error('untrusted checkout url');
    return url.href;
  }

  async function createCheckout(items, discountCode) {
    const lines = items.map((item) => {
      const line = { merchandiseId: 'gid://shopify/ProductVariant/' + item.id, quantity: item.quantity };
      if (item.attributes) line.attributes = Object.keys(item.attributes).map((key) => ({ key, value: String(item.attributes[key]) }));
      return line;
    });
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 15000);
    let response;
    try {
      response = await fetch(SF_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ query: CART_CREATE, variables: { input: { lines, ...(discountCode ? {discountCodes:[discountCode]} : {}) } } }),
        credentials: 'same-origin',
        signal: controller.signal
      });
    } finally {
      window.clearTimeout(timer);
    }
    if (!response.ok) throw new Error('storefront http ' + response.status);
    const payload = await response.json();
    const result = payload && payload.data && payload.data.cartCreate;
    if (!result || (result.userErrors && result.userErrors.length) || !result.cart || !result.cart.checkoutUrl) {
      throw new Error('cartCreate failed');
    }
    return trustedCheckoutUrl(result.cart.checkoutUrl);
  }

  async function addToCart(items, discountCode) {
    const body = {
      items: items.map((item) => {
        const entry = { id: item.id, quantity: item.quantity };
        if (item.attributes) entry.properties = item.attributes;
        return entry;
      })
    };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('cart add ' + response.status);
    const data = await response.json();
    if (discountCode) {
      try {
        const applied = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({discount: discountCode}),
          credentials: 'same-origin'
        });
        if (!applied.ok) throw new Error('discount update failed');
      } catch (_) {
        window.location.assign('/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart');
      }
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return data;
  }

  function initTabs(root) {
    if (root.dataset.fv2Ready) return;
    root.dataset.fv2Ready = 'true';
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const select = (tab) => {
      const more = root.querySelector('[data-fv2-more]');
      if (more && tab.dataset.fv2MoreUrl) {
        more.href = tab.dataset.fv2MoreUrl;
        more.textContent = tab.dataset.fv2MoreLabel;
      }
      tabs.forEach((item) => {
        const on = item === tab;
        item.setAttribute('aria-selected', on ? 'true' : 'false');
        item.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const step = event.key === 'ArrowLeft' ? 1 : -1;
        const next = tabs[(index + step + tabs.length) % tabs.length];
        select(next);
        next.focus();
      });
    });
  }

  function initSort(select) {
    if (select.dataset.fv2Ready) return;
    select.dataset.fv2Ready = 'true';
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  function initProduct(root) {
    if (root.dataset.fv2Ready) return;
    const configEl = root.querySelector('[data-fv2-config]');
    if (!configEl) return;
    let cfg;
    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (_) {
      return;
    }
    root.dataset.fv2Ready = 'true';

    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => Array.from(root.querySelectorAll(selector));
    const state = {
      variant: cfg.variants.find((v) => v.id === cfg.current) || cfg.variants[0],
      offer: cfg.duvetOffers && cfg.offers
        ? ({'1':'single','2':'double','3':'triple'}[new URL(window.location.href).searchParams.get('offer')] || 'single')
        : (cfg.defaultOffer || 'single'),
      addonTarget: 1,
      addonsByPiece: {1:{cases:false,sheet:false,size:''},2:{cases:false,sheet:false,size:''},3:{cases:false,sheet:false,size:''}},
      extraPillows: false,
      pillowOfferSeen: false,
      busy: false
    };

    const sticky = $('[data-fv2-sticky]');
    const totals = $$('[data-fv2-total]');
    const buyButtons = $$('[data-fv2-buy]');
    const addButtons = $$('[data-fv2-add]');
    const msg = $('[data-fv2-msg]');
    const offerInputs = $$('[data-fv2-offer]');
    offerInputs.forEach((input) => { input.checked = input.value === state.offer; });
    const secondWrap = $('[data-fv2-second]');
    const secondSelect = $('[data-fv2-second-select]');
    const quiltPickers = $$('[data-fv2-picker]');
    const otherDesigns = $('[data-fv2-other-designs]');
    const boxQuilts = $('[data-fv2-box-quilts]');
    const singleBoxText = boxQuilts ? boxQuilts.textContent : '';
    const doublePrice = $('[data-fv2-double-price]');
    const doubleSep = $('[data-fv2-double-sep]');
    const boxPillows = $('[data-fv2-box-pillows]');
    const quantityDesigns = $('[data-fv2-quantity-designs]');
    const addonTarget = $('[data-fv2-addon-target]');
    const sheetSize = $('[data-fv2-sheet-size]');
    const addonList = $('[data-fv2-addon-list]');

    const setMsg = (text) => { if (msg) msg.textContent = text || ''; };

    // Gallery
    const track = $('[data-fv2-track]');
    const slides = track ? Array.from(track.children) : [];
    const thumbs = $$('[data-fv2-thumb]');
    const counter = $('[data-fv2-count]');
    const showSlide = (slide) => {
      if (!slide || !track) return;
      const delta = slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollBy({ left: delta, behavior: 'smooth' });
    };
    if (track && slides.length > 1 && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = slides.indexOf(entry.target);
          thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === index ? 'true' : 'false'));
          if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach((slide) => observer.observe(slide));
    }
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(slides[Number(thumb.dataset.fv2Thumb)])));

    // Pricing
    const chosenQuilt = (piece) => {
      const input = $('[data-fv2-quilt="' + piece + '"]:checked');
      if (input) return { id: Number(input.value), price: Number(input.dataset.price), name: input.dataset.name, image: input.dataset.image, stockLimit: Number(input.dataset.stockLimit ?? -1) };
      if (piece === 2 && secondSelect) {
        const option = secondSelect.options[secondSelect.selectedIndex];
        if (option) return { id: Number(option.value), price: Number(option.dataset.price || state.variant.price) };
      }
      return state.variant;
    };
    const quiltCount = () => state.offer === 'triple' ? 3 : state.offer === 'double' ? 2 : 1;
    const quiltAt = (piece) => quiltCount() === 1 ? { ...state.variant, name: cfg.currentName, image: cfg.currentImage } : chosenQuilt(piece);
    const selectedAddons = () => {
      if (!cfg.duvetOffers) return [];
      const result = [];
      for (let piece = 1; piece <= quiltCount(); piece++) {
        const selected = state.addonsByPiece[piece];
        const quilt = quiltAt(piece);
        const attributes = { 'تصميم اللحاف': quilt.name, 'اللحاف': String(piece), _duvet_variant: String(quilt.id), _upsell_source: 'fur-duvet-v3' };
        if (selected.cases) result.push({ ...cfg.addons.cases, key:'cases', piece, quantity:1, attributes, label:cfg.text.cases_title + ' — ' + quilt.name });
        const sheet = cfg.addons.sheet[selected.size];
        if (selected.sheet && sheet) result.push({ ...sheet, key:'sheet', piece, quantity:1, attributes:{ ...attributes, 'المقاس':selected.size }, label:cfg.text.sheet_title + ' ' + selected.size + ' — ' + quilt.name });
      }
      if (state.extraPillows) result.push({ ...cfg.addons.pillows, key:'pillows', piece:0, quantity:1, attributes:{_upsell_source:'fur-duvet-v3'}, label:cfg.text.pillows_summary });
      return result;
    };
    const bundleVariant = () => {
      const ids = Array.from({length:quiltCount()}, (_, i) => String(quiltAt(i + 1).id));
      return (cfg.bundleVariants || {})[ids.sort().join('-')];
    };
    const shippingCode = () => cfg.duvetOffers && quiltCount() > 1 ? cfg.shippingCode : '';
    const selectedStockAvailable = () => {
      const quantities = new Map();
      for (let piece = 1; piece <= quiltCount(); piece++) {
        const quilt = quiltAt(piece);
        const used = (quantities.get(quilt.id) || 0) + 1;
        quantities.set(quilt.id, used);
        if (quilt.stockLimit >= 0 && used > quilt.stockLimit) return false;
      }
      return true;
    };
    const initializeDesignStock = () => {
      const quantities = new Map();
      quiltPickers.forEach((picker) => {
        const options = Array.from(picker.querySelectorAll('[data-fv2-quilt]'));
        const canSelect = (input) => {
          const limit = Number(input.dataset.stockLimit ?? -1);
          return limit < 0 || (quantities.get(input.value) || 0) < limit;
        };
        const preferred = options.find((input) => input.checked);
        const chosen = preferred && canSelect(preferred) ? preferred : options.find(canSelect);
        if (!chosen) return;
        chosen.checked = true;
        quantities.set(chosen.value, (quantities.get(chosen.value) || 0) + 1);
      });
    };
    const updateDesignStock = () => {
      const quantities = new Map();
      for (let piece = 1; piece <= quiltCount(); piece++) {
        const id = String(quiltAt(piece).id);
        quantities.set(id, (quantities.get(id) || 0) + 1);
      }
      quiltPickers.forEach((picker) => {
        const piece = Number(picker.dataset.fv2Picker);
        const selected = String(quiltAt(piece).id);
        picker.querySelectorAll('[data-fv2-quilt]').forEach((input) => {
          const limit = Number(input.dataset.stockLimit ?? -1);
          const elsewhere = (quantities.get(input.value) || 0) - (piece <= quiltCount() && input.value === selected ? 1 : 0);
          input.disabled = limit >= 0 && elsewhere >= limit;
        });
      });
    };
    const canOrder = () => !cfg.duvetOffers || (cfg.newOffersReady === true && selectedStockAvailable() && (quiltCount() === 1 || (!!bundleVariant() && (!cfg.bundleAvailability || cfg.bundleAvailability[String(bundleVariant())] === true))));
    const total = () => {
      const price = state.variant.price;
      if (cfg.duvetOffers) {
        const base = quiltCount() === 1 ? price : cfg.offerPrices[state.offer];
        return base + selectedAddons().reduce((sum, item) => sum + item.price, 0);
      }
      if (state.offer === 'bundle') return price + cfg.pillowPrice - cfg.d1;
      if (state.offer === 'double') return chosenQuilt(1).price + chosenQuilt(2).price + cfg.pillowPrice - cfg.d2;
      return price;
    };

    const renderAddons = () => {
      if (!cfg.duvetOffers) return;
      const count = quiltCount();
      state.addonTarget = Math.min(state.addonTarget, count);
      const targetWrap = $('[data-fv2-addon-target-wrap]');
      if (targetWrap) targetWrap.hidden = count === 1;
      if (addonTarget) {
        addonTarget.replaceChildren();
        for (let piece = 1; piece <= count; piece++) {
          const option = document.createElement('option');
          option.value = String(piece);
          option.textContent = cfg.text['piece_' + piece] + ' — ' + quiltAt(piece).name;
          addonTarget.appendChild(option);
        }
        addonTarget.value = String(state.addonTarget);
      }
      const selected = state.addonsByPiece[state.addonTarget];
      const quilt = quiltAt(state.addonTarget);
      const matching = $('[data-fv2-addon-match]');
      if (matching) {
        matching.replaceChildren();
        if (quilt.image) {
          const img = document.createElement('img');
          img.src = quilt.image;
          img.alt = '';
          img.width = 36;
          img.height = 36;
          matching.appendChild(img);
        }
        const label = document.createElement('span');
        label.textContent = cfg.text.matching_label + ' ' + quilt.name;
        matching.appendChild(label);
      }
      if (sheetSize) sheetSize.value = selected.size;
      const sheet = cfg.addons.sheet[selected.size];
      const sheetPrice = $('[data-fv2-sheet-price]');
      if (sheetPrice) sheetPrice.textContent = sheet ? money(sheet.price) : cfg.text.from + ' ' + money(cfg.addons.sheet['120'].price);
      $$('[data-fv2-addon]').forEach((button) => {
        const key = button.dataset.fv2Addon;
        const on = key === 'pillows' ? state.extraPillows : selected[key];
        button.setAttribute('aria-pressed', String(on));
        button.textContent = on ? cfg.text.added : cfg.text.add;
        button.setAttribute('aria-label', (on ? cfg.text.remove : cfg.text.add) + ': ' + cfg.text[key + '_title']);
        button.disabled = !state.variant.available || (key === 'sheet' && !sheet) || (key === 'pillows' && cfg.addons.pillows.available === false);
        button.closest('[data-fv2-addon-card]').classList.toggle('is-added', on);
      });
      const selectedItems = selectedAddons();
      const summary = $('[data-fv2-addon-summary]');
      if (summary) summary.hidden = selectedItems.length === 0;
      if (addonList) {
        addonList.replaceChildren();
        selectedItems.forEach((item) => {
          const li = document.createElement('li');
          const label = document.createElement('span');
          label.textContent = item.label;
          const price = document.createElement('b');
          price.textContent = money(item.price);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.fv2RemoveAddon = item.key;
          remove.dataset.piece = String(item.piece);
          remove.textContent = cfg.text.remove;
          remove.setAttribute('aria-label', cfg.text.remove + ': ' + item.label);
          li.append(label, price, remove);
          addonList.appendChild(li);
        });
      }
    };
    const render = () => {
      const v = state.variant;
      const priceEl = $('[data-fv2-price]');
      const compareEl = $('[data-fv2-compare]');
      const saveEl = $('[data-fv2-save]');
      if (priceEl) priceEl.textContent = money(v.price);
      const discounted = v.compare > v.price;
      if (compareEl) { compareEl.hidden = !discounted; if (discounted) compareEl.textContent = money(v.compare); }
      if (saveEl) { saveEl.hidden = !discounted; if (discounted) saveEl.textContent = 'وفّر ' + money(v.compare - v.price); }
      if (doublePrice) {
        const sep = chosenQuilt(1).price + chosenQuilt(2).price + cfg.pillowPrice;
        doublePrice.textContent = money(sep - cfg.d2);
        if (doubleSep) doubleSep.textContent = money(sep);
      }
      totals.forEach((el) => { el.textContent = money(total()); });
      offerInputs.forEach((input) => {
        const card = input.closest('.fv2-offer');
        if (card) card.classList.toggle('is-checked', input.checked);
      });
      if (secondWrap) {
        secondWrap.hidden = state.offer !== 'double';
        const group = secondWrap.closest('.fv2-offer-group');
        if (group) group.classList.toggle('is-expanded', state.offer === 'double');
      }
      if (otherDesigns) otherDesigns.hidden = cfg.duvetOffers ? quiltCount() > 1 : state.offer === 'double';
      if (boxQuilts) boxQuilts.textContent = state.offer === 'double' ? (cfg.doubleBoxText || singleBoxText) : singleBoxText;
      quiltPickers.forEach((picker) => {
        const chosen = chosenQuilt(Number(picker.dataset.fv2Picker));
        const label = picker.querySelector('[data-fv2-picked-name]');
        const image = picker.querySelector('.fv2-quilt-picker__image');
        if (label) label.textContent = chosen.name;
        if (image && chosen.image) {
          image.removeAttribute('srcset');
          image.src = chosen.image;
        }
      });
      if (cfg.duvetOffers) {
        updateDesignStock();
        const count = quiltCount();
        if (quantityDesigns) {
          quantityDesigns.hidden = count < 2;
          if (count > 1) {
            const host = $('[data-fv2-design-host="' + state.offer + '"]');
            if (host && quantityDesigns.parentElement !== host) host.appendChild(quantityDesigns);
          }
        }
        $$('[data-fv2-design-host]').forEach((host) => host.classList.toggle('is-expanded', count > 1 && host.dataset.fv2DesignHost === state.offer));
        quiltPickers.forEach((picker) => { picker.hidden = Number(picker.dataset.fv2Picker) > count; });
        if (boxQuilts) boxQuilts.textContent = count === 1 ? singleBoxText : count + ' ' + cfg.text.box_quilts;
        if (boxPillows) boxPillows.hidden = !state.extraPillows;
        const notice = $('[data-fv2-preview-notice]');
        if (notice) { notice.hidden = canOrder(); notice.textContent = 'التشكيلة دي مش متاحة في العرض حاليًا. اختار رسمة تانية.'; }
        renderAddons();
      } else if (boxPillows) boxPillows.hidden = state.offer === 'single';
      buyButtons.concat(addButtons).forEach((button) => { button.disabled = !v.available || !canOrder(); });
      const stock = $('[data-fv2-stock]');
      if (stock) {
        stock.textContent = v.available ? 'متوفر في المخزون' : 'نفد من المخزون';
        stock.classList.toggle('fv2-stock--out', !v.available);
      }
    };

    $$('[data-fv2-variant]').forEach((button) => {
      button.addEventListener('click', () => {
        const v = cfg.variants.find((item) => String(item.id) === button.dataset.fv2Variant);
        if (!v) return;
        state.variant = v;
        $$('[data-fv2-variant]').forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
        const label = $('[data-fv2-variant-label]');
        if (label) label.textContent = v.title;
        if (v.mediaId) showSlide(slides.find((slide) => slide.dataset.mediaId === String(v.mediaId)));
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (_) {}
        setMsg('');
        render();
      });
    });

    offerInputs.forEach((input) => input.addEventListener('change', () => {
      if (!input.checked) return;
      state.offer = input.value;
      if (cfg.duvetOffers) {
        const offerUrl = new URL(window.location.href);
        offerUrl.searchParams.set('offer', String(quiltCount()));
        window.history.replaceState(window.history.state, '', offerUrl.toString());
      }
      if (cfg.duvetOffers && quiltCount() > 1) {
        const picker = $('[data-fv2-picker="' + quiltCount() + '"]');
        if (picker) picker.open = true;
      }
      setMsg('');
      render();
    }));
    if (secondSelect) secondSelect.addEventListener('change', render);
    $$('[data-fv2-quilt]').forEach((input) => input.addEventListener('change', () => { setMsg(''); render(); }));

    if (addonTarget) addonTarget.addEventListener('change', () => { state.addonTarget = Number(addonTarget.value); render(); });
    if (sheetSize) sheetSize.addEventListener('change', () => {
      const selected = state.addonsByPiece[state.addonTarget];
      selected.size = sheetSize.value;
      if (!selected.size) selected.sheet = false;
      render();
    });
    $$('[data-fv2-addon]').forEach((button) => button.addEventListener('click', () => {
      const key = button.dataset.fv2Addon;
      const selected = state.addonsByPiece[state.addonTarget];
      if (key === 'pillows') state.extraPillows = !state.extraPillows;
      else if (key === 'cases' || (key === 'sheet' && cfg.addons.sheet[selected.size])) selected[key] = !selected[key];
      setMsg('');
      render();
    }));
    if (addonList) addonList.addEventListener('click', (event) => {
      const button = event.target.closest('[data-fv2-remove-addon]');
      if (!button) return;
      const key = button.dataset.fv2RemoveAddon;
      if (key === 'pillows') state.extraPillows = false;
      else state.addonsByPiece[Number(button.dataset.piece)][key] = false;
      render();
    });

    const lines = () => {
      const v = state.variant;
      const items = [];
      if (cfg.duvetOffers) {
        if (quiltCount() === 1) {
          items.push({id:v.id, quantity:1});
        } else {
          const bundleId = bundleVariant();
          if (!bundleId) return [];
          items.push({id:bundleId, quantity:1, attributes:{_fluff_offer:state.offer}});
        }
        selectedAddons().forEach(({id,quantity,attributes}) => items.push({id,quantity,attributes}));
        return items;
      }
      if (state.offer === 'double') {
        const firstId = chosenQuilt(1).id;
        const secondId = chosenQuilt(2).id;
        if (secondId === firstId) items.push({ id: firstId, quantity: 2 });
        else items.push({ id: firstId, quantity: 1 }, { id: secondId, quantity: 1 });
      } else {
        items.push({ id: v.id, quantity: 1 });
      }
      if (state.offer !== 'single' && cfg.offers && cfg.pillowVariant) {
        items.push({
          id: cfg.pillowVariant,
          quantity: 1,
          attributes: {
            _upsell_source: cfg.source,
            _upsell_offer: state.offer === 'double' ? 'v2-2-quilts-2-soft-pillows' : 'v2-quilt-2-soft-pillows',
            _upsell_accepted: 'yes'
          }
        });
      }
      return items;
    };

    const analyticsPayload = () => ({
      product_id: String(cfg.productId),
      variant_id: String(state.variant.id),
      offer: state.offer,
      upsell_variant_id: String(cfg.pillowVariant || ''),
      offer_context: 'fur_duvet_v2'
    });

    const resetBusy = () => {
      state.busy = false;
      buyButtons.concat(addButtons).forEach((button) => button.classList.remove('is-loading'));
    };

    const checkout = async (button) => {
      if (state.busy || !state.variant.available || !canOrder()) return;
      state.busy = true;
      setMsg('');
      button.classList.add('is-loading');
      const items = lines();
      if (state.offer !== 'single') publish('fluff:upsell_accepted', analyticsPayload());
      try {
        const url = await createCheckout(items, shippingCode());
        window.location.assign(url);
      } catch (_) {
        try {
          await addToCart(items, shippingCode());
          window.location.assign(shippingCode() ? '/discount/' + encodeURIComponent(shippingCode()) + '?redirect=/checkout' : '/checkout');
        } catch (__) {
          resetBusy();
          setMsg(ERR_CHECKOUT);
        }
      }
    };

    const add = async (button) => {
      if (state.busy || !state.variant.available || !canOrder()) return;
      state.busy = true;
      setMsg('');
      button.classList.add('is-loading');
      try {
        await addToCart(lines(), shippingCode());
        toast('اتضاف للسلة', { href: '/cart', label: 'شوف السلة' });
      } catch (_) {
        setMsg(ERR_ADD);
      } finally {
        resetBusy();
      }
    };

    const pillowPopup = $('[data-fv2-pillow-popup]');
    let pillowPopupTrigger = null;
    const closePillowPopup = () => {
      if (pillowPopup && pillowPopup.open) pillowPopup.close();
      document.body.classList.remove('fv2-pillow-popup-open');
      buyButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
    };
    const requestCheckout = (button) => {
      if (state.busy || !state.variant.available || !canOrder()) return;
      if (cfg.duvetOffers && pillowPopup && cfg.addons.pillows.available && !state.extraPillows && !state.pillowOfferSeen) {
        if (pillowPopup.open) return;
        pillowPopupTrigger = button;
        setMsg('');
        pillowPopup.showModal();
        document.body.classList.add('fv2-pillow-popup-open');
        button.setAttribute('aria-expanded', 'true');
        return;
      }
      checkout(button);
    };
    if (pillowPopup) {
      buyButtons.forEach((button) => {
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', pillowPopup.id);
        button.setAttribute('aria-expanded', 'false');
      });
      $('[data-fv2-popup-close]').addEventListener('click', closePillowPopup);
      pillowPopup.addEventListener('close', () => {
        document.body.classList.remove('fv2-pillow-popup-open');
        buyButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      });
      pillowPopup.addEventListener('click', (event) => {
        if (event.target !== pillowPopup) return;
        const bounds = pillowPopup.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closePillowPopup();
      });
      const completePillowOffer = (accept) => {
        if (!pillowPopup.open || state.busy) return;
        const button = pillowPopupTrigger;
        state.pillowOfferSeen = true;
        if (accept) state.extraPillows = true;
        closePillowPopup();
        render();
        if (button) checkout(button);
      };
      $('[data-fv2-popup-accept]').addEventListener('click', () => completePillowOffer(true));
      $('[data-fv2-popup-decline]').addEventListener('click', () => completePillowOffer(false));
    }
    buyButtons.forEach((button) => button.addEventListener('click', () => requestCheckout(button)));
    addButtons.forEach((button) => button.addEventListener('click', () => add(button)));
    window.addEventListener('pageshow', (event) => { if (event.persisted) resetBusy(); });

    // Sticky order bar: visible on mobile while the main order button is off screen.
    const anchor = $('[data-fv2-buy-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      document.body.appendChild(sticky);
      sticky.hidden = false;
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0 }).observe(anchor);
    }

    if (cfg.duvetOffers) initializeDesignStock();
    render();
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-fv2-tabs]').forEach(initTabs);
    root.querySelectorAll('[data-fv2-sort]').forEach(initSort);
    root.querySelectorAll('[data-fv2-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();





